import { render } from "./PriceIncreaseListView.vue?vue&type=template&id=39d4c854&scoped=true"
import script from "./PriceIncreaseListView.vue?vue&type=script&lang=js"
export * from "./PriceIncreaseListView.vue?vue&type=script&lang=js"

import "./PriceIncreaseListView.vue?vue&type=style&index=0&id=39d4c854&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d4c854"]])

export default __exports__